const firebaseConfig = {
    apiKey: "AIzaSyAK4nLFk_uzJseRgSRVz2KQJLtdDgj_atA",
    authDomain: "healthcare-website-assig-c76ee.firebaseapp.com",
    projectId: "healthcare-website-assig-c76ee",
    storageBucket: "healthcare-website-assig-c76ee.appspot.com",
    messagingSenderId: "303872351502",
    appId: "1:303872351502:web:9a162853345084ec1e8b5f"
};
export default firebaseConfig;